export type Env = {
  apiUrl: string;
  clientId: string;
  enableCronJobsTesting?: boolean;
};

export function getEnvVar<Key extends keyof Env>(envKey: Key): Env[Key] {
  const envVar = window.env[envKey];
  if (envVar === undefined)
    throw new Error(`Missing environment variable: ${envKey}`);

  return envVar;
}

export function isCronJobsTestingEnabled(): boolean {
  return window.env.enableCronJobsTesting === true;
}
